import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import * as _ from "lodash";

import { URLSearchParams } from '@angular/http'
import { HttpBackendService } from "app/services/http-backend.service";
import { ProblemTemplate } from "app/models/problemTemplate";

@Injectable()
export class ProblemTemplateService {

  constructor(
    private _http: HttpBackendService
  ) { }

  public getProblemTemplates(): Observable<ProblemTemplate[]> {
    let params = new URLSearchParams;
    params.append('$filter', "IsDeleted eq false");
    params.append('$select', "Id,Name");
    params.append('$orderby', "Name asc")

    return this._http.get("/api/odata/problemTemplates", params, true)
      .map(resp => {

        var problemTemplates = _.map(resp.json().value, function (value) {
          return ProblemTemplateService.convertProblemTemplateDTO2Object(value);
        });

        return problemTemplates;
      });
  }

  public getCallProblemTemplate(): Observable<ProblemTemplate[]> {
    let params = new URLSearchParams;
    
    return this._http.get("/api/problemtemplate/getcallproblemtemplates", null, true)
      .map(resp => {
        var problemTemplates = _.map(resp.json(), function (value) {
          return ProblemTemplateService.convertProblemTemplateDTO2Object(value);
        });

        return problemTemplates;
      });
  }
}

export namespace ProblemTemplateService {
  export function convertProblemTemplateDTO2Object(dto: any, problemTemplate: ProblemTemplate = new ProblemTemplate()): ProblemTemplate {
    problemTemplate.id = dto.Id;
    problemTemplate.name = dto.Name;

    return problemTemplate;
  };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/problemTemplate.service.ts